export class AnimalVariety {
    public static BLACK_AND_WHITE = new AnimalVariety('PB', 'BLACK_AND_WHITE');
    public static RED_AND_WHITE = new AnimalVariety('VB', 'RED_AND_WHITE');
    public static OTHER = new AnimalVariety('OTHER', 'OTHER');

    public constructor(
        public readonly acronym: string,
        public readonly description: string
    ) { }

    public static values(): AnimalVariety[] {
        return [
            AnimalVariety.BLACK_AND_WHITE,
            AnimalVariety.RED_AND_WHITE,
            AnimalVariety.OTHER
        ];
    }

    public static get(description: string): AnimalVariety {
        const animalVariety = AnimalVariety.values().find(it => it.description === description);
        if(!animalVariety) {
            throw new Error(`${description} is not a mapped AnimalVariety.`);
        }
        return animalVariety
    }
}
